import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss']
})
export class ServiceComponent implements OnInit {

  logo=[
    {
      'url' : '/assets/logo/pupr_logo.png'
    },
    {
      'url' : '/assets/logo/brin_logo.png'
    },
    {
      'url' : '/assets/logo/pln_logo.png'
    },
    {
      'url' : '/assets/logo/wika_logo.png'
    },
    
   
    {
      'url' : '/assets/logo/polri_logo.png'
    },
    {
      'url' : '/assets/logo/tni_logo.png'
    },
    {
      'url' : '/assets/logo/pp_logo.png'
    },
    {
      'url' : '/assets/logo/logo_ui.png'
    },
    
  ]
  constructor(

    private route: ActivatedRoute,
    
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      console.log('hihi')
      window.scroll({ 
        top: 0, 
        left: 0, 
      
      });



    })

  }

}
